import { render, staticRenderFns } from "./PreReceiving.vue?vue&type=template&id=47851f88"
import script from "./PreReceiving.vue?vue&type=script&lang=js"
export * from "./PreReceiving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports